<template>
  <li v-if="block.data.text" :class="classes">
    <BlocksCoreText :block="block" class="is-first" />
    <Blocks :blocks="block?.blocks" />
  </li>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
  props.block?.data?.style ? props.block?.data?.style : null,
].filter(str => str).join(' ')
</script>

<style lang="scss" scoped>
//
</style>
